module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "loader": "spinner",
      "color": "#36304a",
      "width": 70
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Location Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form')], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Location Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.LocationTypeNameFilter,
      "option-value": "LocationTypeVal",
      "option-text": "LocationTypeText",
      "placeholder": "Select Location Type"
    },
    on: {
      "input": function($event) {
        _vm.getData('0', '1', '1')
      }
    },
    model: {
      value: (_vm.locationTypeFilter),
      callback: function($$v) {
        _vm.locationTypeFilter = $$v
      },
      expression: "locationTypeFilter"
    }
  })], 1), _vm._v(" "), (
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
    _vm.$sessionsStorage.get('cust_username') == 'admin'
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "option-value": "StatusTypeVal",
      "option-text": "StatusTypeTxt",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [(_vm.showMain == false) ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New\n              Location")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export to Excel' ? true : false,
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_Location_Master_Report', 'Export to Excel')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export to Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.showMain == true) ? _c('div', [_c('div', [_c('b-card', [_c('b-card-text', [(_vm.pickupLocation.locationType == '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('u', [_vm._v("Note:-Select Location Type to Continue..!")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.pickupId != '') ? _c('div', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteData(_vm.pickupLocation.pickupId)
      }
    }
  }, [_vm._v("Delete Location")])], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "locationType"
    }
  }, [_vm._v("Select Location Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.LocationTypeList,
      "option-value": "LocationTypeVal",
      "option-text": "LocationTypeText",
      "placeholder": "Select Location Type"
    },
    model: {
      value: (_vm.pickupLocation.locationType),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "locationType", $$v)
      },
      expression: "pickupLocation.locationType"
    }
  }), _vm._v(" "), (!_vm.pickupLocation.locationType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.locationTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Enquiry Pricing")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.enqPriceList,
      "option-value": "val",
      "option-text": "valTxt",
      "placeholder": "Select Enquiry Pricing"
    },
    model: {
      value: (_vm.pickupLocation.is_enq_price),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "is_enq_price", $$v)
      },
      expression: "pickupLocation.is_enq_price"
    }
  }), _vm._v(" "), (!_vm.pickupLocation.is_enq_price) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.is_enq_priceError))]) : _vm._e()], 1), _vm._v(" "), (_vm.pickupLocation.is_enq_price == 1) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.is_enq_price == 1) ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("TERRITORY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "enq_price_loc_territory",
      "name": "enq_price_loc_territory",
      "placeholder": "Enter TERRITORY"
    },
    model: {
      value: (_vm.pickupLocation.enq_price_loc_territory),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "enq_price_loc_territory", $$v)
      },
      expression: "pickupLocation.enq_price_loc_territory"
    }
  }), _vm._v(" "), (!_vm.pickupLocation.enq_price_loc_territory) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.enq_price_loc_territoryError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.pickupLocation.locationType != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [(
    _vm.pickupLocation.locationType == 'Client_Factory' ||
    _vm.pickupLocation.locationType == 'Icd' ||
    _vm.pickupLocation.locationType == '5' ||
    _vm.pickupLocation.locationType == '6'
  ) ? _c('label', [_vm._v("Location Name")]) : _c('label', [_vm._v("Port Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mainLocation",
      "name": "mainLocation"
    },
    on: {
      "keyup": _vm.checkAlready
    },
    model: {
      value: (_vm.pickupLocation.mainLocation),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "mainLocation", $$v)
      },
      expression: "pickupLocation.mainLocation"
    }
  }), _vm._v(" "), (_vm.pickupLocationArrayError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pickupLocationArrayError))]) : _vm._e()], 1), _vm._v(" "), (!_vm.pickupLocation.mainLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pickupLocationError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.locationType == '5') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.locationType == '5') ? _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Branch Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "BranchCode",
      "name": "BranchCode"
    },
    model: {
      value: (_vm.pickupLocation.BranchCode),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "BranchCode", $$v)
      },
      expression: "pickupLocation.BranchCode"
    }
  })], 1), _vm._v(" "), (!_vm.pickupLocation.BranchCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.BranchCodeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.locationType == '5') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.locationType == '5') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v(" Default Billing Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.billingLocationData,
      "option-value": "billingLocationId",
      "option-text": "billingLocation",
      "placeholder": "Select Billing Location"
    },
    on: {
      "input": _vm.getBillingBranch
    },
    model: {
      value: (_vm.pickupLocation.billingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "billingLocationId", $$v)
      },
      expression: "pickupLocation.billingLocationId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Client_Factory' ||
    _vm.pickupLocation.locationType == 'Icd'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Client_Factory' ||
    _vm.pickupLocation.locationType == 'Icd'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Latitude")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.pickupLocation.latitude),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "latitude", $$v)
      },
      expression: "pickupLocation.latitude"
    }
  })], 1), _vm._v(" "), (!_vm.pickupLocation.latitude) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.latitudeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Sea_Port' ||
    _vm.pickupLocation.locationType == 'Air_Port'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portCode",
      "name": "portCode"
    },
    model: {
      value: (_vm.pickupLocation.portCode),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "portCode", $$v)
      },
      expression: "pickupLocation.portCode"
    }
  })], 1), _vm._v(" "), (!_vm.pickupLocation.portCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.portCodeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Sea_Port' ||
    _vm.pickupLocation.locationType == 'Air_Port'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Sea_Port' ||
    _vm.pickupLocation.locationType == 'Air_Port'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "portlocationType"
    }
  }, [_vm._v("Port Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.portLocationTypeList,
      "option-value": "portLocationTypeVal",
      "option-text": "portLocationTypeText",
      "placeholder": "Select Port Type"
    },
    model: {
      value: (_vm.pickupLocation.portLocationType),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "portLocationType", $$v)
      },
      expression: "pickupLocation.portLocationType"
    }
  }), _vm._v(" "), (!_vm.pickupLocation.portLocationType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.portlocationTypeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Sea_Port' ||
    _vm.pickupLocation.locationType == 'Air_Port'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Sea_Port' ||
    _vm.pickupLocation.locationType == 'Air_Port'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Location (Country Name)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portLocation",
      "name": "portLocation"
    },
    model: {
      value: (_vm.pickupLocation.portLocation),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "portLocation", $$v)
      },
      expression: "pickupLocation.portLocation"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Client_Factory' ||
    _vm.pickupLocation.locationType == 'Icd'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Longitude")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "longitude",
      "name": "longitude"
    },
    model: {
      value: (_vm.pickupLocation.longitude),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "longitude", $$v)
      },
      expression: "pickupLocation.longitude"
    }
  })], 1), _vm._v(" "), (!_vm.pickupLocation.longitude) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.longitudeError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Sea_Port' ||
    _vm.pickupLocation.locationType == 'Air_Port'
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("State Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mainLocation",
      "name": "mainLocation"
    },
    model: {
      value: (_vm.pickupLocation.stateName),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "stateName", $$v)
      },
      expression: "pickupLocation.stateName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("State Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portCode",
      "name": "portCode"
    },
    model: {
      value: (_vm.pickupLocation.stateCode),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "stateCode", $$v)
      },
      expression: "pickupLocation.stateCode"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Special Instruction")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "address",
      "id": "address"
    },
    model: {
      value: (_vm.pickupLocation.specialInstruction),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "specialInstruction", $$v)
      },
      expression: "pickupLocation.specialInstruction"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (
    (_vm.pickupLocation.locationType != '' &&
      _vm.pickupLocation.locationType != 'Sea_Port') ||
    _vm.pickupLocation.locationType != 'Air_Port'
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "address",
      "id": "address"
    },
    model: {
      value: (_vm.pickupLocation.address),
      callback: function($$v) {
        _vm.$set(_vm.pickupLocation, "address", $$v)
      },
      expression: "pickupLocation.address"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pickupLocation.locationType != '') ? _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addVehicleSize
    }
  }, [_vm._v("Save")]), _vm._v(" "), (
    _vm.pickupLocation.locationType == 'Client_Factory' &&
    _vm.pickupLocation.pickupId != ''
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Please Add Client Factory From Client Master")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    on: {
      "input": function($event) {
        _vm.getData('0', '1')
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.vehicleSizeMaster,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "locationType",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.value == "5" ? "Pridel Branch" : row.value == "6" ? "CFS" : row.value))])]
      }
    }, {
      key: "pickupLocation",
      fn: function(row) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.editLocation(row.item)
            }
          }
        }, [_vm._v(_vm._s(row.value))]), _c('br')]
      }
    }, {
      key: "pickupId",
      fn: function(row2) {
        return [_vm._v("\n              " + _vm._s(row2.item.pickupId) + "\n              "), (_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row2.item.pickupId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row2.item.pickupId,
            "name": "approval",
            "value": row2.item.pickupIsActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row2.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row2.item.pickupIsActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row2.item.pickupId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row2.item.pickupIsActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "add_console_booking_pre",
      fn: function(row) {
        return [(row.item.locationType == '5') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row.item.add_console_booking_pre,
            "name": "approval",
            "value": row.item.add_console_booking_pre === '1'
          },
          on: {
            "change": function($event) {
              _vm.activateBookingPref(row.item)
            }
          }
        }, [_c('h6', [_c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row.item.add_console_booking_pre == 1 ?
          "Yes" :
          "No"))])], 1)]) : _vm._e()]
      }
    }, {
      key: "is_noe_validation",
      fn: function(row) {
        return [(row.item.locationType == '5') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row.item.is_noe_validation,
            "name": "approval",
            "value": row.item.is_noe_validation === '1'
          },
          on: {
            "change": function($event) {
              _vm.activateNatureOfExpensePref(row.item)
            }
          }
        }, [_c('h6', [_c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row.item.is_noe_validation == 1 ?
          "Yes" :
          "No"))])], 1)]) : _vm._e()]
      }
    }, {
      key: "is_expense_validation",
      fn: function(row) {
        return [(row.item.locationType == '5') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row.item.is_expense_validation,
            "name": "approval",
            "value": row.item.is_expense_validation === '1'
          },
          on: {
            "change": function($event) {
              _vm.activateExpensePref(row.item)
            }
          }
        }, [_c('h6', [_c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row.item.is_expense_validation == 1 ?
          "Yes" :
          "No"))])], 1)]) : _vm._e()]
      }
    }, {
      key: "is_additional_task_validation",
      fn: function(row) {
        return [(row.item.locationType == '5') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row.item.is_additional_task_validation,
            "name": "approval",
            "value": row.item.is_additional_task_validation === '1'
          },
          on: {
            "change": function($event) {
              _vm.activateAdditionalTaskPref(row.item)
            }
          }
        }, [_c('h6', [_c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row.item.is_additional_task_validation == 1 ?
          "Yes" :
          "No"))])], 1)]) : _vm._e()]
      }
    }, {
      key: "is_sline_validation",
      fn: function(row) {
        return [(row.item.locationType == '5') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row.item.is_sline_validation,
            "name": "approval",
            "value": row.item.is_sline_validation === '1'
          },
          on: {
            "change": function($event) {
              _vm.activateSlinePref(row.item)
            }
          }
        }, [_c('h6', [_c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row.item.is_sline_validation == 1 ?
          "Yes" :
          "No"))])], 1)]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28446319","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/locationMaster/pickupLocation.vue
// module id = 2476
// module chunks = 0